var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "Modal",
        {
          attrs: {
            title: "未成年人模式",
            "class-name": "vertical-center-modal my-modal",
            "mask-closable": false,
            width: "400",
            "footer-hide": true
          },
          on: { "on-cancel": _vm.close },
          model: {
            value: _vm.modalShow,
            callback: function($$v) {
              _vm.modalShow = $$v
            },
            expression: "modalShow"
          }
        },
        [
          _c("div", { staticClass: "tc" }, [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "space-between",
                  "align-items": "center",
                  width: "80%",
                  margin: "0 auto"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "img-item",
                    staticStyle: { "padding-top": "5px" }
                  },
                  [
                    _c("img", {
                      staticStyle: {
                        display: "inline",
                        width: "40px",
                        height: "40px"
                      },
                      attrs: { src: require("../../assets/img/live/01.png") }
                    }),
                    _vm._v(" "),
                    _c("p", { staticStyle: { "margin-top": "5px" } }, [
                      _vm._v("消费限制")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "img-item" }, [
                  _c("img", {
                    staticStyle: {
                      display: "inline",
                      width: "45px",
                      height: "45px"
                    },
                    attrs: { src: require("../../assets/img/live/02.png") }
                  }),
                  _vm._v(" "),
                  _c("p", { staticStyle: { "margin-top": "5px" } }, [
                    _vm._v("内容精选")
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "img-item" }, [
                  _c("img", {
                    staticStyle: {
                      display: "inline",
                      width: "45px",
                      height: "45px"
                    },
                    attrs: { src: require("../../assets/img/live/03.png") }
                  }),
                  _vm._v(" "),
                  _c("p", { staticStyle: { "margin-top": "5px" } }, [
                    _vm._v("时长控制")
                  ])
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "tc", staticStyle: { margin: "15px 0" } }, [
            _c("span", { staticStyle: { color: "#27b110" } }, [
              _vm._v("未成年人模式已开启")
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tc" },
            [
              _c(
                "ButtonGroup",
                { attrs: { shape: "circle" } },
                [
                  _c(
                    "Button",
                    {
                      staticStyle: { width: "230px" },
                      attrs: { type: "warning" },
                      on: { click: _vm.showNext }
                    },
                    [_vm._v("退出未成年人模式")]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("setD", { ref: "setDRef" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e20c004", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e20c004","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wcn/setC.vue
// module id = null
// module chunks = 